import { useEffect } from 'react'

/**
 * useBodyScrollLock
 * Bloque le scroll de la page (html + body) tant que `isLocked` est true.
 */
export default function useBodyScrollLock(isLocked) {
  useEffect(() => {
    if (!isLocked) return

    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
    const html = document.documentElement
    const body = document.body

    // Bloquer html ET body (certains navigateurs scrollent html, pas body)
    const prevHtmlOverflow   = html.style.overflow
    const prevBodyOverflow   = body.style.overflow
    const prevBodyPadding    = body.style.paddingRight
    const prevHtmlPadding    = html.style.paddingRight

    html.style.overflow     = 'hidden'
    html.style.paddingRight = `${scrollbarWidth}px`
    body.style.overflow     = 'hidden'
    body.style.paddingRight = `${scrollbarWidth}px`

    return () => {
      html.style.overflow     = prevHtmlOverflow
      html.style.paddingRight = prevHtmlPadding
      body.style.overflow     = prevBodyOverflow
      body.style.paddingRight = prevBodyPadding
    }
  }, [isLocked])
}